<template>
	<section class="view-venue-revision">
		<section class="cta padded pull-top-xl">
			<p class="small" style="margin-bottom: 0">Want to add a photo or update some info?</p>
			<button class="button-secondary size-x-small" v-on:click="Handle_OnClickAddRevision">Revise</button>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Place
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueRevision extends ViewBase {
		/**
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Trigger the global submit modal pre-seeded with the current venue so
		 * revisions go through the shared flow (jumps straight to details slide).
		 *
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAddRevision(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('modal:submit:open', {
				venueModel: this.venueModel,
			});
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-revision {
		.cta {
			align-items: center;
			display: flex;
			gap: 1rem;
			justify-content: center;
		}
	}
</style>
